export const ascNumberComparator = (a, b) => a - b;
export const descNumberComparator = (a, b) => b - a;
